(function () {
  'use strict';
  var root = document.querySelector('.orn-pdp[data-section-type="product"]');
  if (!root) return;

  /* ---------- Gallery: counter, dots, label, variant media ---------- */
  var viewport = root.querySelector('[data-orn-carousel]');
  var counter = root.querySelector('[data-orn-counter]');
  var dots = root.querySelectorAll('.orn-gallery__dot');
  var label = root.querySelector('[data-orn-label]');
  var slides = viewport ? viewport.querySelectorAll('[data-orn-slide]') : [];

  function updateGallery() {
    if (!viewport || !slides.length || viewport.scrollWidth <= viewport.clientWidth + 1) return;
    var i = Math.round(viewport.scrollLeft / viewport.clientWidth);
    i = Math.max(0, Math.min(slides.length - 1, i));
    if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
    if (label) label.textContent = slides[i].getAttribute('data-label') || '';
  }
  if (viewport) {
    viewport.addEventListener('scroll', updateGallery, { passive: true });
    updateGallery();
  }

  var mediaMap = {};
  try {
    var mapEl = root.querySelector('[data-orn-variant-media]');
    if (mapEl) mediaMap = JSON.parse(mapEl.textContent);
  } catch (e) {}

  /* ---------- Variant sync (MRP saving, stock, gallery) ---------- */
  var lastId = null;
  function currentId() {
    var sel = root.querySelector('[name="id"]');
    var id = sel && sel.value;
    if (!id) id = new URL(location.href).searchParams.get('variant');
    return id;
  }
  function showFor(id) {
    root.querySelectorAll('[data-orn-variant]').forEach(function (el) {
      el.hidden = el.getAttribute('data-orn-variant') !== String(id);
    });
  }
  function scrollToVariantMedia(id) {
    var mid = mediaMap[id];
    if (!mid || !viewport || viewport.scrollWidth <= viewport.clientWidth + 1) return;
    slides.forEach(function (s) {
      if (String(s.getAttribute('data-media-id')) === String(mid)) {
        viewport.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
      }
    });
  }
  function sync() {
    var id = currentId();
    if (!id) return;
    showFor(id);
    if (lastId !== null && id !== lastId) scrollToVariantMedia(id);
    lastId = id;
    render();
  }
  lastId = currentId();
  var priceEl = root.querySelector('[data-price]');
  if (priceEl) {
    new MutationObserver(function () { sync(); setTimeout(sync, 150); })
      .observe(priceEl, { childList: true, characterData: true, subtree: true });
  }
  root.addEventListener('click', function () { setTimeout(sync, 400); });
  root.addEventListener('change', function () { setTimeout(sync, 100); });

  /* ---------- Accordions (mobile; always open on desktop via CSS) ---------- */
  root.querySelectorAll('[data-orn-acc]').forEach(function (acc) {
    var btn = acc.querySelector('[data-orn-acc-btn]');
    var body = acc.querySelector('[data-orn-acc-body]');
    var sign = acc.querySelector('.orn-acc__sign');
    if (!btn || !body) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      body.hidden = open;
      if (sign) sign.textContent = open ? '+' : '−';
    });
  });

  /* ---------- Free-shipping nudge + "+ Add" ---------- */
  var nudge = root.querySelector('[data-orn-nudge]');
  var goal = nudge ? parseFloat(nudge.getAttribute('data-orn-goal')) || 0 : 0;
  var moneyFormat = root.getAttribute('data-orn-money-format') || 'Rs. {{amount}}';
  var prices = {};
  try { prices = JSON.parse(nudge.querySelector('[data-orn-prices]').textContent); } catch (e) {}
  var lastCart = null;

  function group(n, dec, thousands, decimal) {
    var parts = n.toFixed(dec).split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return parts[0] + (parts[1] ? decimal + parts[1] : '');
  }
  function money(cents) {
    var v = cents / 100;
    var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var t = m ? m[1] : 'amount';
    var s;
    if (t === 'amount_no_decimals') s = group(v, 0, ',', '.');
    else if (t === 'amount_with_comma_separator') s = group(v, 2, '.', ',');
    else if (t === 'amount_no_decimals_with_comma_separator') s = group(v, 0, '.', ',');
    else s = group(v, 2, ',', '.');
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, s);
  }
  function inCart(cart, variantId) {
    return cart.items.some(function (i) { return String(i.variant_id) === String(variantId); });
  }

  function render() {
    if (!nudge || !goal || !lastCart) return;
    var id = currentId();
    var base = lastCart.total_price + (inCart(lastCart, id) ? 0 : (prices[id] || 0));
    var remaining = goal - base;
    var title = nudge.querySelector('[data-orn-nudge-title]');
    var fill = nudge.querySelector('[data-orn-nudge-fill]');
    var have = nudge.querySelector('[data-orn-nudge-have]');
    var goalEl = nudge.querySelector('[data-orn-nudge-goal]');
    if (title) title.textContent = remaining > 0 ? 'Add ' + money(remaining) + ' more for free shipping' : '✓ Free shipping unlocked';
    if (fill) fill.style.width = Math.max(0, Math.min(100, (base / goal) * 100)) + '%';
    if (have) have.textContent = money(base);
    if (goalEl) goalEl.textContent = money(goal);
    nudge.querySelectorAll('[data-orn-add]').forEach(function (btn) {
      setBtn(btn, inCart(lastCart, btn.getAttribute('data-orn-add')));
    });
    nudge.querySelectorAll('[data-orn-select]').forEach(function (a) {
      var handle = a.getAttribute('data-orn-handle');
      setBtn(a, lastCart.items.some(function (i) { return i.handle === handle; }));
    });
    var ship = nudge.querySelector('[data-orn-ship]');
    if (ship) ship.hidden = (prices[id] || 0) >= goal;
    var labels = nudge.querySelector('.orn-nudge__labels');
    if (labels) labels.hidden = remaining <= 0;
  }

  function rowTitle(btn) {
    var n = btn.closest('.orn-nudge__item');
    n = n && n.querySelector('.orn-nudge__name');
    return n ? n.textContent.replace(/s+/g, ' ').trim() : '';
  }
  function setBtn(btn, has) {
    if (btn.__busy) return; // mid-add: keeps its "Adding…" state; set again once the add settles
    var label = has ? (btn.getAttribute('data-added-label') || 'Added ✓') : (btn.getAttribute('data-orn-label') || '+ Add');
    btn.classList.toggle('is-added', has);
    btn.textContent = label;
    if (has) {
      var x = document.createElement('span');
      x.className = 'orn-btn-add__x';
      x.setAttribute('aria-hidden', 'true');
      x.textContent = '×';
      btn.appendChild(x);
      btn.setAttribute('aria-label', 'Remove ' + rowTitle(btn));
    } else {
      btn.removeAttribute('aria-label');
    }
  }

  // Remove ONE unit of the exact variant (or, for multi-variant rows, of the added line for that product)
  function undo(btn) {
    if (btn.__busy) return;
    btn.__busy = true;
    var vid = btn.getAttribute('data-orn-add');
    var handle = btn.getAttribute('data-orn-handle');
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = cart.items.filter(function (i) {
          return vid ? String(i.variant_id) === String(vid) : i.handle === handle;
        })[0];
        if (!line) return null;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: Math.max(0, line.quantity - 1) })
        }).then(function (r) { if (!r.ok) throw r; return r.json(); });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        return refreshNudge();
      })
      .catch(function () { return refreshNudge(); })
      .then(function () { btn.__busy = false; });
  }

  function refreshNudge() {
    if (!nudge) return Promise.resolve();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { lastCart = cart; render(); })
      .catch(function () {});
  }
  refreshNudge();

  root.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-add-to-cart]')) {
      setTimeout(refreshNudge, 1200);
      setTimeout(refreshNudge, 2600);
    }
  });
  ['cart:item-added', 'cart:updated', 'apps:product-added-to-cart'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(refreshNudge, 500); });
  });

  root.querySelectorAll('[data-orn-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-added')) { undo(btn); return; }
      if (btn.__busy) return; // repeat tap while adding: ignored
      btn.__busy = true;
      // Cart drawer on: the drawer adds (one request), shows the piece at once and handles errors
      if (window.ornCart && window.ornCart.addVariant) {
        var item = btn.closest('.orn-nudge__item');
        var pick = function (s) { return item && item.querySelector(s); };
        var pt = pick('.orn-nudge__price'), pm = pt && pt.textContent.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
        window.ornCart.busy(btn, true);
        window.ornCart.addVariant({
          id: Number(btn.getAttribute('data-orn-add')), qty: 1, trigger: btn,
          preview: { title: pick('.orn-nudge__name') ? pick('.orn-nudge__name').textContent.trim() : '', img: pick('.orn-nudge__img img') ? pick('.orn-nudge__img img').src : null, unit: pm ? Math.round(parseFloat(pm[1]) * 100) : 0 },
          done: function () { window.ornCart.busy(btn, false); btn.__busy = false; refreshNudge(); }
        }).catch(function () { window.ornCart.busy(btn, false); btn.__busy = false; });
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(btn.getAttribute('data-orn-add')), quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
          if (window.ornCart) window.ornCart.added({ trigger: btn }); // cart drawer (theme setting): show the bag
          return refreshNudge();
        })
        .catch(function () {})
        .then(function () { btn.__busy = false; });
    });
  });

  /* ---------- Multi-variant "Select": reuse the theme's quick-view modal, add via AJAX ---------- */
  var qsBtn = null;
  var watchedModal = null;
  function getModal() { return document.querySelector('[data-quick-view-modal]'); }

  // When the modal closes (add, X, backdrop or Esc) forget the opener and return focus to it
  function watchModal(m) {
    if (watchedModal === m) return;
    watchedModal = m;
    var wasVisible = false;
    new MutationObserver(function () {
      var visible = m.classList.contains('is-visible');
      if (wasVisible && !visible && qsBtn) {
        var opener = qsBtn;
        qsBtn = null;
        window.__ornQsOpen = false;
        // not while the cart drawer has just opened over the page (it returns focus to the opener itself)
        setTimeout(function () { if (!document.documentElement.classList.contains('orn-cd-lock')) opener.focus(); }, 60);
      }
      wasVisible = visible;
    }).observe(m, { attributes: true, attributeFilter: ['class'] });
  }

  if (nudge) {
    nudge.addEventListener('click', function (e) {
      var sel = e.target.closest('[data-orn-select]');
      if (!sel) return;
      if (sel.classList.contains('is-added')) { e.preventDefault(); undo(sel); return; }
      var url = sel.getAttribute('data-orn-select');
      var modalEl = getModal();
      var trigger = modalEl && document.querySelector('[data-quick-shop-trigger="quick-view"][data-product-url="' + url + '"]');
      if (!trigger) { window.location.href = url; return; } // theme quick-view unavailable for this product: use its page
      watchModal(modalEl);
      e.preventDefault();
      qsBtn = sel;
      window.__ornQsOpen = true; // the cart drawer bootstrap leaves this pop-up's add to us
      trigger.click();
    });

    // Keep the shopper on the page: add the chosen variant with the AJAX cart API. Taken at the button click, not the
    // form submit: Shopify counts a submitted /cart/add form and the AJAX add as two product_added_to_cart events.
    document.addEventListener('click', function (e) {
      var quickModal = getModal();
      var btn = e.target.closest && e.target.closest('button, input[type=submit]');
      var form = btn && btn.form;
      if (!qsBtn || !quickModal || !form || btn.type !== 'submit' || !quickModal.contains(form)) return;
      if (!form.matches('form[action*="/cart/add"]') || !form.checkValidity()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      // Cart drawer on: the drawer closes the pop-up, shows the piece at once and adds it (one request)
      if (window.ornCart && window.ornCart.addForm) { window.ornCart.addForm(form, btn); return; }
      var fd = new FormData(form);
      var submit = form.querySelector('[data-add-to-cart]');
      var old = form.parentNode.querySelector('.orn-qs-error');
      if (old) old.remove();
      if (submit) submit.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          var close = quickModal.querySelector('[data-modal-close]');
          var opener = qsBtn;
          if (close) close.click();
          document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
          if (window.ornCart) window.ornCart.added({ trigger: opener }); // cart drawer (theme setting): show the bag
          return refreshNudge();
        })
        .catch(function (err) {
          if (submit) submit.disabled = false;
          var p = document.createElement('p');
          p.className = 'orn-qs-error';
          p.setAttribute('role', 'alert');
          p.textContent = (err && (err.description || err.message)) || 'Sorry, this could not be added. Please try again.';
          form.parentNode.insertBefore(p, form.nextSibling);
        });
    }, true);
  }
})();

/* ---------- Judge.me reviews slider helpers (arrows + "read more"); does not touch Judge.me's own code ---------- */
(function () {
  'use strict';
  var sec = document.querySelector('[data-section-id*="1777449829a0cef55e"]');
  if (!sec) return;

  var nav = document.createElement('div');
  nav.className = 'orn-rv-nav';
  nav.hidden = true;
  nav.innerHTML = '<button type="button" class="orn-rv-nav__btn" data-dir="-1" aria-label="Previous reviews">&#8249;</button>' +
                  '<button type="button" class="orn-rv-nav__btn" data-dir="1" aria-label="Next reviews">&#8250;</button>';
  sec.appendChild(nav);

  function activeList() {
    var lists = sec.querySelectorAll('.jdgm-review-list');
    for (var i = 0; i < lists.length; i++) { if (lists[i].offsetParent !== null) return lists[i]; }
    return null;
  }
  function gapOf(list) { return parseFloat(getComputedStyle(list).columnGap) || 0; }

  function markClamped() {
    sec.querySelectorAll('.jm-review-item').forEach(function (it) {
      if (it.classList.contains('orn-rv-expanded')) return;
      var body = it.querySelector('.jdgm-review-content__body-content');
      if (!body) return;
      it.classList.toggle('orn-rv-clamped', body.scrollHeight > body.clientHeight + 1);
    });
  }
  function updateNav() {
    var l = activeList();
    var can = !!l && l.scrollWidth > l.clientWidth + 2;
    nav.hidden = !can;
    if (!can) return;
    var btns = nav.querySelectorAll('button');
    btns[0].disabled = l.scrollLeft <= 2;
    btns[1].disabled = l.scrollLeft + l.clientWidth >= l.scrollWidth - 2;
  }

  var t = null;
  function refresh() { clearTimeout(t); t = setTimeout(function () { markClamped(); updateNav(); }, 200); }
  new MutationObserver(refresh).observe(sec, { childList: true, subtree: true });
  window.addEventListener('resize', refresh);
  sec.addEventListener('scroll', updateNav, true);
  refresh();

  nav.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    var l = activeList();
    if (!l) return;
    var card = l.querySelector('.jm-review-item');
    var step = card ? card.getBoundingClientRect().width + gapOf(l) : l.clientWidth;
    l.scrollBy({ left: step * parseInt(b.getAttribute('data-dir'), 10), behavior: 'smooth' });
  });

  sec.addEventListener('click', function (e) {
    var it = e.target.closest('.jm-review-item');
    if (!it || e.target.closest('a, button')) return;
    if (it.classList.contains('orn-rv-clamped')) it.classList.toggle('orn-rv-expanded');
  });
})();

/* ---------- Share button: native share sheet on touch devices, otherwise a small popover ---------- */
(function () {
  'use strict';
  var root = document.querySelector('.orn-pdp [data-orn-share]');
  if (!root) return;
  var btn = root.querySelector('.orn-share__btn');
  var pop = root.querySelector('.orn-share__pop');
  var status = root.querySelector('[data-orn-share-status]');
  var copyLabel = root.querySelector('[data-orn-share-copy-label]');
  var url = root.getAttribute('data-url');
  var title = root.getAttribute('data-title');
  var image = root.getAttribute('data-image');
  var id = root.getAttribute('data-id');

  // Share tracking used to push a 'share' event into GTM's dataLayer; GTM is retired (Oct 2026), so nothing consumes it.
  // Kept as a no-op hook (Shopify's Google & YouTube pixel shares window.dataLayer and must not receive stray events).
  function track(method) {}
  function priceText() {
    var p = document.querySelector('.orn-pdp .orn-price__now');
    return p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function shareText() { var p = priceText(); return title + (p ? ' – ' + p : '') + ' at Ornamint'; }
  function refreshLinks() {
    var t = shareText(), e = encodeURIComponent;
    root.querySelector('[data-orn-share-method="whatsapp"]').href = 'https://wa.me/?text=' + e(t + ' ' + url);
    root.querySelector('[data-orn-share-method="facebook"]').href = 'https://www.facebook.com/sharer/sharer.php?u=' + e(url);
    root.querySelector('[data-orn-share-method="pinterest"]').href = 'https://www.pinterest.com/pin/create/button/?url=' + e(url) + '&media=' + e(image) + '&description=' + e(t);
  }
  function open() { refreshLinks(); pop.hidden = false; btn.setAttribute('aria-expanded', 'true'); var f = pop.querySelector('.orn-share__opt'); if (f) f.focus(); }
  function close(focusBtn) { if (pop.hidden) return; pop.hidden = true; btn.setAttribute('aria-expanded', 'false'); if (focusBtn) btn.focus(); }

  btn.addEventListener('click', function () {
    var data = { title: title, text: shareText(), url: url };
    // Native share sheet only on touch devices; desktop (fine pointer) always gets the popover
    var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (touch && navigator.share && (!navigator.canShare || navigator.canShare(data))) {
      navigator.share(data).then(function () { track('native'); }, function () {});
      return;
    }
    if (pop.hidden) open(); else close(false);
  });
  pop.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-orn-share-method]');
    if (!opt) return;
    var method = opt.getAttribute('data-orn-share-method');
    if (method !== 'copy_link') { track(method); close(false); return; }
    function done() {
      track('copy_link');
      copyLabel.textContent = 'Link copied ✓';
      if (status) status.textContent = 'Link copied';
      setTimeout(function () { copyLabel.textContent = 'Copy link'; if (status) status.textContent = ''; }, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { fallbackCopy(); done(); });
    } else { fallbackCopy(); done(); }
  });
  function fallbackCopy() {
    var ta = document.createElement('textarea');
    ta.value = url; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (err) {}
    ta.remove();
  }
  document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(true); });
})();

/* ---------- Reviews tabs: if the product has no reviews yet, show "Store reviews" first and open it on load ---------- */
(function () {
  'use strict';
  var sec = document.querySelector('[data-section-id*="1777449829a0cef55e"]');
  if (!sec) return;
  var done = false;
  function apply() {
    if (done) return;
    var prodTab = sec.querySelector('#jdgm-tab_product_reviews');
    var shopTab = sec.querySelector('#jdgm-tab_shop_reviews');
    if (!prodTab || !shopTab) return;
    var m = prodTab.textContent.match(/\((\d+)\)/);
    if (!m) return;
    done = true;
    obs.disconnect();
    if (parseInt(m[1], 10) === 0) {
      sec.classList.add('orn-rv-store-first');
      if (shopTab.getAttribute('aria-selected') !== 'true') shopTab.click();
    }
  }
  var obs = new MutationObserver(apply);
  obs.observe(sec, { childList: true, subtree: true, characterData: true });
  apply();
})();
